import * as XLSX from "xlsx";
import moment from 'moment';
import ClevertapReact from 'clevertap-react';

import { toast } from "react-toast";

import { URL, Roles, USER, StatusMapping } from '../../constants/insurance/constant';
import { axiosFinal, _axios } from '../../plugins/axios';
import { INDIGO_ENTITY_ID } from '../../constants/insurance/constant';

export const ESalesDetails = (searchObj, pageNo) => {

  let obj = {};
  let url = "https://api-plus.medibuddy.in//policyBazaarRequests";

  if (searchObj != null && searchObj.Id != null && searchObj.Name != null) {
    const key = searchObj.Name;
    const id = searchObj.Id;
    switch (key) {
      case 'Equote Id': obj = { Equote: id }; break;
      case 'Contact No': obj = { contactno: id }; break;
      default: obj = {}; break;
    }
  }

  let dataAllAppointments = {
    searchType: obj,
    accesstoken: JSON.parse(localStorage.getItem("access_token")),
    RequestFrom: "ESales",
    pageNo: pageNo,
    rows: 10,
  };




  let config = {
    method: "post",
    url: url,
    headers: {
      accesstoken: JSON.parse(localStorage.getItem("access_token"))
    },
    data: dataAllAppointments
  };

  return _axios(config)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj;
      }
    });
}

export const RuleEngine = () => {
  let assignedContract = USER.user.properties["Assigned Contracts"] ;
  let childrens = JSON.parse(localStorage.getItem("children"))
  let id;
  childrens.map(e=>{
    if(e.erTypeId == assignedContract)
      id = e.id
  })
  let data = {
    cartAppointment: [],
    ruleEngineVariable: {
      employeeId: "PB Emp",
      entityRelationId: String(id),
      loadRetailPackages: false,
      maid: "0",
      ruleParams: { String: "String" }
    }
  }

  let config = {
    method: 'post',
    url : URL.providercore_url + 'insurance/ruleEngine',
    data: data,
  };

  return _axios(config)
    .then((response) => response.data)
    .catch((error) => error);

}

export const getStateCityLocalityDC = (type, lookUpId, id) => {
  let url = null;
  let obj ={}
  switch (type) {
    case 'state': 
      url =  URL.providercore_url+ "insurance/getAllStates";
       break;
    case 'city': 
      url =  URL.providercore_url+ "insurance/getCities";
      obj={
        stateLookUpId:lookUpId,
        id:id
      }
      break;
    case 'location': 
      url =  URL.providercore_url+ "insurance/getLocation";
      obj = {
        cityLookUpId:lookUpId
      }
      break;
    default: url = null; break
  }

  if (url != null) {
    let config = {
      method: 'post',
      url: url,
      data:obj
    };

    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }

}


export const formatAMPM = (date) => {
  // let newDate = moment(date.toString()).utc().format("h:mm A")
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
  // return newDate
}

export const getAllDC = (stateId, cityId, locationId, packageIds) => {
  let data = {
    stateId: stateId,
    cityId: cityId,
    locationId: locationId,
    packageIds: packageIds,
    requestAccessToken: JSON.parse(localStorage.getItem("access_token")),
  }

  let config = {
    method: 'post',
    // url: 'https://api-plus.medibuddy.in/AllEligibleDCByPackageIdsAndByLocation',
    url: URL.providercore_url + 'insurance/getAllDC',
    data: data
  };

  return _axios(config)
    .then((response) => response.data)
    .catch((error) => error);

}

export const isInsurerAdmin = () => {
  if (USER.user && USER.user.roleId && USER.user.roleId == Roles.insureradmin){
    return true;
  }else{
    return false;
  }
}

export const isMaReport = () => {
  if (USER.user && USER.user.rolesFeatures?.roles) {
    return USER.user.rolesFeatures.roles.some(role => role.roleId == Roles.mareport);
  } else {
    return false;
  }
}

export const isInsurerAgent = () => {
  if (USER.user && USER.user.roleId && USER.user.roleId == Roles.insureragent){
    return "true";
  }else{
    return "false";
  }
}

export const isInsurerBranch = () => {
  if (USER.user && USER.user.roleId && USER.user.roleId == Roles.insurerbranch){
    return "true";
  }else{
    return "false";
  }
}

export const isInsurerCallCenter = () => {
  if (USER.user && USER.user.roleId && USER.user.roleId == Roles.insurercallCentre){
    return "true";
  }else{
    return "false";
  }
}



export const AppointmentDetails = (searchObj, pageNo, firstDate, endDate, fetchByDate = "NA", exportData=null) => {
  let obj = {};
  let newPayload = {
    isLabwise: true,
    contractIDs: [9782, 4625, 9717],
    corporateIDs: JSON.parse(localStorage.getItem("user_details")).corporateIDs,
    corporateNames: [],
    branchIds: [],
    statusIds:[],
    fetchByDate: fetchByDate,
    fromDateOfAppointment: firstDate,
    toDateOfAppointment: endDate,
    paginationBasedDetail: {
      pageNumber: pageNo,
      recordsPerPage: exportData? exportData : 10
    },
    searchType: "AllAppointment",
    providerIds: [],
    serviceType: [],
    orderType: [],
    sortDetails: [
      {
        priority: 0,
        field: "FulfillmentDate",
        isDescending: true
      }
    ],
    requestAccessToken: localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null,
    roleId:JSON.parse(localStorage.getItem("user_details")).roleId,
    isExportData: exportData? true : false,
    isEsales: fetchByDate=="RequestCreationDate",
  }
  if(fetchByDate === "RequestCreationDate")
  newPayload.EsalesSortDetails="CreatedOn";

  if (
    searchObj != null &&
    searchObj.Id != null &&
    searchObj.Name != null &&
    !(searchObj?.Id?.length == 1 && searchObj?.Id[0].trim() == "")
  ) {
    const key = searchObj.Name;
    const id = searchObj.Id;
    switch (key) {
      case "Request/Esales Id": {
        newPayload["requestID"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Application No": {
        newPayload["employeeID"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Application No / Eqoute": {
        newPayload["employeeID"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Equote Id": {
        newPayload["employeeID"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Contact No": {
        newPayload["mobileNo"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Member Id": {
        newPayload["MAID"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Name": {
        newPayload["patientName"] = id;
        newPayload.isSearch = true;
        break;
      }
      case "Status": {
        const statusIds = StatusMapping.filter(
          (item) => item.StatusNew === id
        ).map((item) => item.statusId);
        newPayload["statusIds"] = statusIds;
        newPayload.isSearch = true;
        break;
      }
      default:
        break;
    }
  }

  let config = {
    method: 'post',
    url: URL.providercore_url + 'insurance/appointments/',
    headers: {
      accesstoken: JSON.parse(localStorage.getItem("access_token")),
      'accept': 'application/json, text/plain, */*',
    },
    data: newPayload
  };
  console.log(config)
  return _axios(config)
    .then((response) => {
      // if(!response.data.isSuccess) 
      // cleverTap("appointmentsFetchFailed", {
      //   message:response.data.errorMessage
      // })
      // else cleverTap("appointmentsFetched", {})
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}


export const getProviderDetails = (entityId) => {
  let config = {
    method: 'post',
    // method: 'get',
    url: URL.providercore_url + 'insurance/getEntityDetails',
    // url: "http://ch-coreprovidermaster.medibuddy.in/providerMaster/EntityList",
    data:{
      "accesstoken": JSON.parse(localStorage.getItem("access_token")),
      "entityListByEntityId": true,
      "entityIds": [
        JSON.parse(localStorage.getItem("user_details")).entityId
      ],
      "operation": "AND",
      "startIndex": 0,
      "range": 0
    }
  };

  return _axios(config)
    .then((response) => response.data.entities[0])
    .catch((error) => error);
}

export const getChildEntityRelation = (entityId) => {
  let config = {
    method: 'get',
    url: URL.ins_medibuddy + 'GetChildEntityRelation/' + entityId,
  };

  return _axios(config)
    .then((response) => response.data)
    .catch((error) => error);
}

export const getAllContracts = () =>{
  let config = {
    method: 'get',
    url: URL.providercore_url + 'insurance/getAllContracts/'
  };

  return _axios(config)
    .then((response) => response.data)
    .catch((error) => error);
}

export const MaskElement = (elementToMask, additionals) => {
  let strToMask = '';
  if (elementToMask) {
    for (let i = 0; i < elementToMask.length; i++) {
      if (i > 4) {
        if (additionals && additionals.DNDCustomer) {
          strToMask = strToMask + '*'
        }
        else if (additionals && additionals.DND) {
          strToMask = strToMask + '*'
        }
        else {
          strToMask = strToMask + elementToMask[i]
        }
      }
      else {
        strToMask = strToMask + elementToMask[i]
      }
    }
  }
  return strToMask;
}


export const getAge = (dateOfBirth) => {
  if (!dateOfBirth || dateOfBirth === "/Date(-62135596800000-0000)/")
    return;
  else {
    var dob = new Date(parseInt(dateOfBirth.replace('/Date(', '').replace(')/', ''), 10))
    var today = new Date();
    var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
    return age;
  }
}

export const getDateObj = (inputDate) => {
  if (inputDate) {
    if(inputDate.indexOf("/Date") > -1){
      var d = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
      return new Date(d);
    }
    else{
      return new Date(inputDate)
    }
  }
}

export const getCustomApptDate = (inputDate) => {
  if (inputDate) {
    let d;
    if (inputDate.indexOf("/Date") > -1) {
      d = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10));
    } else {
      d = new Date(inputDate);
    }

    d.setMinutes(d.getMinutes() - 330); // Subtract 5 hours 30 minutes
    return d;
  }
};

export const getCustomDate = (date) => {
  // let newDate = moment(date.toString()).utc().format("DD-MMM-YYYY")
  let customDate = date.getDate();
  let year = date.getFullYear();
  let month = date.toLocaleString('default', { month: 'short' });
  let dateStr = customDate + "-" + month + "-" + year;
  return dateStr;
  // return newDate
}


export const getAppointmentDate = (fulfillmentDate) => {
  let date = new Date(fulfillmentDate);
  return date.toDateString();
}

export const timeConvert = (time) => {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? ' AM' : ' PM';
    time[0] = +time[0] % 12 || 12;
  }
  return time.join('');
}

export const getCorrectDateFormat = (fulfillmentDate) => {
  let date = fulfillmentDate;
  date = new Date(date);
  return date;
}

export const getAppointmentTime = (fulfillmentDate) => {
  let date = fulfillmentDate;
  date = new Date(date).toTimeString();
  date = date.split(' ')[0]
  return date;
}

export const uploadFile = (reports) => {

  let config = {
    method: 'post',
    url: URL.providercore_url + 'provider/UploadFile/',
    headers: {
      accesstoken: JSON.parse(localStorage.getItem("access_token")),
      'accept': 'multipart/form-data',
      'appId': 10007,
    },
    data: reports
  };

  return axiosFinal(config)
    .then((response) => {
      console.log(response)
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const RouteToDashboard = (history, statusId, stateObject) => {
  switch (statusId) {
    case 0: history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/", state: stateObject }); break;
    case 1: history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/esalesqueue", state: stateObject }); break;
    default: history.push({ pathname: "/" + localStorage.getItem("roleName") + "/appointments/", state: stateObject }); break;
  }
}


export const getAppointmentDateFormat = (fulfillmentDate) => {
  let date = fulfillmentDate.split('/')[1]
  date = date.split('(')[1];
  date = date.split('-')[0];
  date = new Date(parseInt(date));
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  date = new Date(year, month, day);
  let dateObject = new Date(date);
  return dateObject.toDateString();
}


export const getAppointmentTimeFormat = (fulfillmentDate) => {
  let date = fulfillmentDate.split('/')[1]
  date = date.split('(')[1];
  date = date.split('-')[0];
  date = new Date(parseInt(date));

  let stringDate = new Date(date).toUTCString()
  let stringExceptGMT = stringDate.split(' GMT')[0];
  stringExceptGMT = stringExceptGMT.split(' ');
  stringExceptGMT = stringExceptGMT[stringExceptGMT.length - 1]
  return stringExceptGMT;
}
const exportFile = (data) => {
  console.log(data)
  
  const workBook = XLSX.utils.book_new(); // create a new blank book
  const workSheet = XLSX.utils.json_to_sheet(data);

  XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
  XLSX.writeFile(workBook, 'temp.xlsx'); // initiate a file download in browser
};

function formatTheDate(rawdate){
  const date = new Date(rawdate);
  const defaultResponse = "Not Applicable";
  if(date.getTime() === 0) return defaultResponse;
  return date.toDateString();
}

function exportPayload(elem){
  const userDetails = JSON.parse(localStorage.getItem('user_details') || '{}');
  const isIndigoEntity = userDetails.entityId && INDIGO_ENTITY_ID === userDetails.entityId;
  let defaultPayload = {              
    "Request Id" : elem?.customerDetails?.requestID,
    "Employee Id" : elem?.customerDetails?.empId,
    "Email" : elem?.customerDetails?.email,
    "Contact Number" : elem?.customerDetails?.phonePrimary,
    "Patient Name" : elem?.customerDetails?.name,
    "Corporate Name" : elem?.customerDetails?.corporateName,
    "Status Name" : elem?.labeling?.currentStatusText,
    "Package" : elem?.appointmentDetails?.productName,
    "Appointment Date" : elem?.appointmentDetails?.firstAppointmentDate,
    "Provider Name" : elem?.appointmentDetails?.providerName,
    "Provider City" : elem?.appointmentDetails?.dcCity,
    "Provider Id" : elem?.appointmentDetails?.providerId,
    "Visit Type" : elem?.appointmentDetails?.visitType,
    "Member Id" : elem?.customerDetails?.maid,
    "Patient Address" : elem?.appointmentDetails?.addressLine1 + ' ' + elem?.appointmentDetails?.addressLine2,
    "Gender" : elem?.customerDetails?.gender === "M" ? "Male" : "Female",
    "Age" : elem?.customerDetails?.age     
  };

  if(isIndigoEntity){
    let additionalPayload = {
      "Esales Created On": formatTheDate(elem?.appointmentDetails?.additionals?.EsalesCaseDateCreation),
      "Reports Uploaded On": formatTheDate(elem?.IndigoAdditionalFields?.lastReportUploadDate),
      "QC Verified On":formatTheDate(elem?.IndigoAdditionalFields?.QCApprovedDate),
      "Esales Remark":elem?.IndigoAdditionalFields?.EQLastCallRemark
    };
    defaultPayload = {...defaultPayload, ...additionalPayload};
  }
  return defaultPayload;
}

const makeData = (data, isAppointment) =>{
  if (isAppointment) {
    let XLSXData =  data?.activerequests?.appointmentList?.map((elem,i) => {
      return (exportPayload(elem));
    });
    return XLSXData;
  }
  else { 
    let XLSXData =  data?.queueRequests?.queueList.map(elem => {
      return (
        {
          "EQuote": elem?.eQuote,
          "Name": elem?.name,
          "Email": elem?.email,
          "PhoneNumber": elem?.phoneNo,
          "CorporateName": elem?.corporateName,
          "City": elem?.requestJSON?.city,
          "State": elem?.requestJSON?.state,
          "Created": elem?.dateTimeCreated,
        }
      )
    })
    return XLSXData;
  }
}

export const exportData = async (searchObj,pageNo, firstDate, endDate, fetchByDate = "NA", isAppointment) => {
  const userDetails = JSON.parse(localStorage.getItem('user_details') || '{}');
  const isIndigoEntity = userDetails.entityId && INDIGO_ENTITY_ID === userDetails.entityId;
  let count = 100;
  if(isIndigoEntity && firstDate && endDate){
    const thresholdLimitInDaysays =  Math.abs(new Date(endDate) - new Date(firstDate)) / 864e5;
    if(thresholdLimitInDaysays >= 93){
      toast.error("Please select a date range of 90 days (One Quarter) or less for exporting data.");
      return;
    }
    await AppointmentDetails(searchObj, 0, firstDate, endDate, fetchByDate).then( data =>{
      if(data) count = data.activerequests.totalActiveRequest;
    });
  }
  let data = await AppointmentDetails(searchObj, 0, firstDate, endDate, fetchByDate, count);
  if ( data?.isSuccess && (data?.activerequests?.isSuccess || data?.queueRequests?.isSuccess)) {
    exportFile(await makeData(data,isAppointment));
  }
}

export const cleverTap = (eventName, eventData = {}) => {
  let data = {
    providerId: localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).providerId : null,
    srcType: "web/mWeb",
    srcPage: window.location.hash,
    ...eventData
  }
  if ((window.location.hostname === 'labwise.medibuddy.in') && eventName) {
    ClevertapReact.event(eventName, data);
  }
}

export const getAgeOfUser = (dateString) => {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const isDateBeforeToday = (date) => {
  return new Date(date.toDateString()) < new Date(new Date().toDateString());
}


export const checkSlaTime = (timeString, breachLimit) => {
  let a = moment(timeString);
  let hrs = moment().diff(a, "hours")
  let days = moment().diff(a, "days")
  let months = moment().diff(a, "months")
  if (months > 0) return { month: months }
  if (hrs < 0) return null;
  if (hrs > 0) {
    if (hrs < breachLimit) return null;
    else {
      if (hrs < 24) return { hour: hrs };
      if (days > 0 && months === 0) return { day: days, hour: (hrs - 24 * days) }
    }
  }
}

export const downloadReports = async (contractId, firstTime, secondTime ) => {
  // let fileName = "test";
  // let url =  URL.ins_medibuddy + 'DownloadFile/'+contractId+'/'+firstTime+'/'+secondTime+'/'+fileName
  // return url;
  let user = JSON.parse(localStorage.getItem("user_details") || '{}');
  let erIds = user ? user?.parentProvider?.isParent ? 
              ( user.selectedProviders && 
                user.selectedProviders.length !== 0 ? 
                user.selectedProviders : 
                user?.corporateIDs 
              ) : user?.corporateIDs : null;

  erIds = erIds ? erIds.map(id => id.toString()) : null;

  const data = {
    "ZipFileName": "test",
    "RequestId": "",
    "OrderId": 0,
    "EntityRelationId": erIds,
    "ApprovalStartDate": "",
    "ApprovalEndDate": "",
    "ApprovalStartTimeInUnix": firstTime.getTime(),
    "ApprovalEndTimeInUnix": secondTime.getTime()
  };

  const config = {
    method: 'post',
    url: `${URL.ins_medibuddy}DownloadFile`,
    headers: { 
      'Content-Type': 'application/json',
      'accesstoken': (localStorage.getItem("access_token") || "").replaceAll('"', '')
    },
    data,
    responseType: 'blob'
  };

  try {
    const response = await _axios(config);
    const blob = response.data;
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = `From${firstTime.toLocaleDateString()}${firstTime.toLocaleTimeString()}To${secondTime.toLocaleDateString()}${secondTime.toLocaleTimeString()}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error("Failed to download reports");
  }
}

export const getFileDownload = async (fileName, guid) => {

  let tokenValid = await checkTokenExpiry();
  if(!tokenValid){
    return {
      "message": "tokenExpired"
    }
  }
  
  let config = {
    method: 'post',
    url:  URL.providercore_url + 'insurance/DownloadFile',
    headers: {
      accesstoken: USER.access_token,
      'accept': 'application/json, text/plain, */*',
    },
    responseType:"arraybuffer",
    data:{
      "fileGuid":guid?.split('/').pop(),
      "fileName":fileName
  }
  };

  return _axios(config)
    .then((response) =>{
      console.log("response\n",response)
      return response.data;
    })
    .then(data=>( new Blob([data], { type: "octet/stream" }) ))
    .then(blob=>{return window.URL.createObjectURL(blob)})
    .then(url=>{
      document.getElementById("hiddenDownloadLink").setAttribute("href",url);
      document.getElementById("hiddenDownloadLink").setAttribute("download",`${fileName}`);
      document.getElementById("hiddenDownloadLink").click();
      document.getElementById("hiddenDownloadLink").setAttribute("href","");
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

const checkTokenExpiry = async () =>{
  const data = {
    applicationId: 5385,
    authToken: JSON.parse(localStorage.getItem("access_token"))
  }

  var config = {
    method: 'post',
    url: URL.providercore_url + "provider/validateToken",
    headers: {
        'Content-Type': 'application/json'
    },
    data: data
};

return _axios(config)
.then(res=>{
  console.log(res)
  return res.data})
.then(resp=>{
  if(resp && resp.isSuccess){
    return  true
  }else
    return false
})
.catch(err=>{
  console.log(err);
  return false;
})

}